export interface KinoklubProgram {
  id: number;
  date: string;
  title: string;
  price: string;
  ticketUrl?: string;
  cinema: string;
  hall: string;
  tags: string[];
  hour: string;
  isRunning: boolean;
}

export type KinoklubCinema =
  | 'biooko'
  | 'aero'
  | 'svetozor'
  | 'lucerna'
  | 'pritomnost'
  | 'biocentral'
  | 'scala';

export type KinoklubLanguage = 'en' | 'cs';

export enum KinoklubCinemaChoices {
  Aero = 1,
  Oko = 2,
  Svetozor = 3,
  Scala = 5,
  BioCentral = 6,
  Pritomnost = 7,
  Lucerna = 9
}

export enum KinoklubHallSvetozorChoices {
  SvetozorLarge = 1,
  SvetozorSmall = 2,
  SvetozorThird = 3,
  SvetozorOther = 24
}

export enum KinoklubHallLucernaChoices {
  LucernaLarge = 34,
  LucernaSmall = 35
}

export enum KinoklubHallOkoChoices {
  OkoLarge = 10,
  OkoSmall = 23
}

export interface KinoklubProgramOptions {
  allDays?: boolean;
}
